export default __webpack_public_path__ + "static/media/descriptor.33ff713b.svg";